import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const ExportReportsApi = createApi({
  reducerPath: "ExportReports",
  baseQuery: fetchBaseQuery({
    baseUrl: `${process.env.REACT_APP_API_URL}/reports`,
    prepareHeaders: (headers) => {
      const token = localStorage.getItem("token");
      if (token) {
        headers.set("Authorization", `Bearer ${token}`);
      }
      // headers.set(
      //   "Accept",
      //   "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
      // );
      return headers;
    },
    credentials: "include",
  }),
  endpoints: (builder) => ({
    getExportVehicleRoutes: builder.query({
      async queryFn(args, _queryApi, _extraOptions, fetchWithBQ) {
        const { from: startdate, to: enddate, selectedids: ids } = args;

        const result = await fetch(
          `${process.env.REACT_APP_API_URL}/reports/route?from=${startdate}&to=${enddate}&excludeIdle=true&${ids}`,
          {
            method: "GET",
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`,
              "Content-Type": "application/json",
              Accept:
                "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            },
          }
        );

        if (!result.ok) {
          return {
            error: { status: result.status, data: await result.text() },
          };
        }

        const blob = await result.blob();

        return { data: blob };
      },
    }),
    getExportVehicleTrips: builder.query({
      async queryFn(args, _queryApi, _extraOptions, fetchWithBQ) {
        const { from: startdate, to: enddate, selectedids: ids } = args;

        const result = await fetch(
          `${process.env.REACT_APP_API_URL}/reports/trips?from=${startdate}&to=${enddate}&${ids}`,
          {
            method: "GET",
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`,
              "Content-Type": "application/json",
              Accept:
                "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            },
          }
        );

        if (!result.ok) {
          return {
            error: { status: result.status, data: await result.text() },
          };
        }

        const blob = await result.blob();

        return { data: blob };
      },
    }),
    getExportStop: builder.query({
      async queryFn(args, _queryApi, _extraOptions, fetchWithBQ) {
        const { from: startdate, to: enddate, selectedids: ids } = args;

        const result = await fetch(
          `${process.env.REACT_APP_API_URL}/reports/stops?from=${startdate}&to=${enddate}&${ids}`,
          {
            method: "GET",
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`,
              "Content-Type": "application/json",
              Accept:
                "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            },
          }
        );

        if (!result.ok) {
          return {
            error: { status: result.status, data: await result.text() },
          };
        }

        const blob = await result.blob();

        return { data: blob };
      },
    }),
    getExportSummary: builder.query({
      async queryFn(args, _queryApi, _extraOptions, fetchWithBQ) {
        const { from: startdate, to: enddate, selectedids: ids } = args;

        const result = await fetch(
          `${process.env.REACT_APP_API_URL}/reports/summary?from=${startdate}&to=${enddate}&daily=true&${ids}`,
          {
            method: "GET",
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`,
              "Content-Type": "application/json",
              Accept:
                "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            },
          }
        );

        if (!result.ok) {
          return {
            error: { status: result.status, data: await result.text() },
          };
        }

        const blob = await result.blob();

        return { data: blob };
      },
    }),
    getExportRoutePdf: builder.query({
      async queryFn(args, _queryApi, _extraOptions, fetchWithBQ) {
        const { from: startdate, to: enddate, selectedids: ids } = args;

        const result = await fetch(
          `${process.env.REACT_APP_API_URL}/reports/route?from=${startdate}&to=${enddate}&excludeIdle=true&${ids}`,
          {
            method: "GET",
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`,
              Accept: "application/pdf",
            },
          }
        );

        if (!result.ok) {
          return {
            error: { status: result.status, data: await result.text() },
          };
        }

        const blob = await result.blob();

        return { data: blob };
      },
    }),
    getExportTripsPdf: builder.query({
      async queryFn(args, _queryApi, _extraOptions, fetchWithBQ) {
        const { from: startdate, to: enddate, selectedids: ids } = args;

        const result = await fetch(
          `${process.env.REACT_APP_API_URL}/reports/trips?from=${startdate}&to=${enddate}&${ids}`,
          {
            method: "GET",
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`,
              Accept: "application/pdf",
            },
          }
        );

        if (!result.ok) {
          return {
            error: { status: result.status, data: await result.text() },
          };
        }

        const blob = await result.blob();

        return { data: blob };
      },
    }),
    getExportStopsPdf: builder.query({
      async queryFn(args, _queryApi, _extraOptions, fetchWithBQ) {
        const { from: startdate, to: enddate, selectedids: ids } = args;

        const result = await fetch(
          `${process.env.REACT_APP_API_URL}/reports/stops?from=${startdate}&to=${enddate}&${ids}`,
          {
            method: "GET",
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`,
              Accept: "application/pdf",
            },
          }
        );

        if (!result.ok) {
          return {
            error: { status: result.status, data: await result.text() },
          };
        }

        const blob = await result.blob();

        return { data: blob };
      },
    }),
    getExportSummaryPdf: builder.query({
      async queryFn(args, _queryApi, _extraOptions, fetchWithBQ) {
        const { from: startdate, to: enddate, selectedids: ids } = args;

        const result = await fetch(
          `${process.env.REACT_APP_API_URL}/reports/summary?from=${startdate}&to=${enddate}&daily=true&${ids}`,
          {
            method: "GET",
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`,
              Accept: "application/pdf",
            },
          }
        );

        if (!result.ok) {
          return {
            error: { status: result.status, data: await result.text() },
          };
        }

        const blob = await result.blob();

        return { data: blob };
      },
    }),
    getExportMaintenanceExcel: builder.query({
      async queryFn({ filterQuery = "" }, _queryApi, _extraOptions) {
        const qs = filterQuery ? `?${filterQuery}` : "";
        const result = await fetch(
          `${process.env.REACT_APP_BACKEND3_URL}/reports/maintenance/export/excel${qs}`,
          {
            method: "GET",
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`,
              Accept:
                "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            },
          }
        );

        if (!result.ok) {
          return {
            error: { status: result.status, data: await result.text() },
          };
        }

        const blob = await result.blob();
        return { data: blob };
      },
    }),
    getExportMaintenancePdf: builder.query({
      async queryFn({ filterQuery = "" }, _queryApi, _extraOptions) {
        const qs = filterQuery ? `?${filterQuery}` : "";
        const result = await fetch(
          `${process.env.REACT_APP_BACKEND3_URL}/reports/maintenance/export/pdf${qs}`,
          {
            method: "GET",
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`,
              Accept: "application/pdf",
            },
          }
        );

        if (!result.ok) {
          return {
            error: { status: result.status, data: await result.text() },
          };
        }

        const blob = await result.blob();
        return { data: blob };
      },
    }),
  }),
});

export const {
  useLazyGetExportVehicleRoutesQuery,
  useLazyGetExportVehicleTripsQuery,
  useLazyGetExportStopQuery,
  useLazyGetExportSummaryQuery,
  useLazyGetExportRoutePdfQuery,
  useLazyGetExportTripsPdfQuery,
  useLazyGetExportStopsPdfQuery,
  useLazyGetExportSummaryPdfQuery,
  useLazyGetExportMaintenanceExcelQuery,
  useLazyGetExportMaintenancePdfQuery,
} = ExportReportsApi;
